import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import HydratedIcon from "../../../assets/wellness/Hydrated.svg";
import ExerciseIcon from "../../../assets/wellness/Excercise.svg";
import BreakIcon from "../../../assets/wellness/Took A Break.svg";
import CommunicateIcon from "../../../assets/wellness/Communicate.svg";
import NotYetIcon from "../../../assets/wellness/Not Yet.svg";

const WellnessPoll = ({ onResponseChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = [
    { label: "Hydrated", icon: HydratedIcon, value: "Hydrated" },
    { label: "Exercised", icon: ExerciseIcon, value: "Exercised" },
    { label: "Took a Break", icon: BreakIcon, value: "Took a Break" },
    { label: "Communicate", icon: CommunicateIcon, value: "Communicate" },
  ];

  const handleOptionClick = (value) => {
    setSelectedOptions((prev) => {
      if (value === "notYet") {
        // Clear all other selections and do not send anything to backend
        onResponseChange && onResponseChange("wellnessPoll", undefined);
        return ["notYet"];
      } else {
        // If "Nothing Yet" is selected, deselect it
        const withoutNotYet = prev.filter((item) => item !== "notYet");
  
        // Toggle the clicked option
        if (withoutNotYet.includes(value)) {
          const updatedSelections = withoutNotYet.filter((item) => item !== value);
          onResponseChange &&
            onResponseChange(
              "wellnessPoll",
              updatedSelections.length > 0 ? updatedSelections : undefined
            );
          return updatedSelections;
        } else {
          const updatedSelections = [...withoutNotYet, value];
          onResponseChange &&
            onResponseChange(
              "wellnessPoll",
              updatedSelections.length > 0 ? updatedSelections : undefined
            );
          return updatedSelections;
        }
      }
    });
  };  

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: "center",
        gap: { xs: 0, sm: 10 },
        padding: "2rem",
        boxSizing: "border-box",
        borderRadius: "12px",
        backgroundColor: "background.default",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        minHeight: "60vh",
      }}
    >
      {/* Title and Description */}
      <Box
        sx={{
          flex: { xs: "none", sm: 1 },
          textAlign: { xs: "center", sm: "left" },
          marginBottom: { xs: "2rem", sm: 0 },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            marginBottom: "1rem",
            color: "#333",
          }}
        >
          Wellness Poll
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.25rem",
            color: "#666",
            marginBottom: "2rem",
          }}
        >
          Which of these did you do today to care for yourself?
        </Typography>
      </Box>

      {/* Options and "Nothing Yet" */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "center",
          gap: "2rem",
        }}
      >
        {/* Options Group */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "0.5rem",
            width: { xs: "100%", sm: "auto" },
          }}
        >
          {options.map((option, index) => (
            <Box
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                minWidth: "100px",
                padding: "2rem",
                backgroundColor: selectedOptions.includes(option.value)
                  ? "#142850"
                  : "#E0E0E0",
                borderRadius: {
                  xs:
                    index === 0
                      ? "12px 0 0 0"
                      : index === 1
                      ? "0 12px 0 0"
                      : index === 2
                      ? "0 0 0 12px"
                      : "0 0 12px 0",
                },
                transition: "background-color 0.3s ease-in-out",
              }}
            >
              <img
                src={option.icon}
                alt={option.label}
                style={{
                  width: "60px",
                  marginBottom: "0.5rem",
                  filter: selectedOptions.includes(option.value)
                    ? "none"
                    : "brightness(70%)",
                  transition: "filter 0.3s ease-in-out",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: selectedOptions.includes(option.value)
                    ? "#FFF"
                    : "#666",
                }}
              >
                {option.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* "Nothing Yet" Option */}
        <Box
          onClick={() => handleOptionClick("notYet")}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            padding: "1rem",
            backgroundColor: selectedOptions.includes("notYet")
              ? "#142850"
              : "transparent",
            borderRadius: "8px",
            transition: "background-color 0.3s ease-in-out",
          }}
        >
          <img
            src={NotYetIcon}
            alt="Not Yet"
            style={{
              width: "60px",
              marginBottom: "0.5rem",
              filter: selectedOptions.includes("notYet")
                ? "brightness(0) invert(1)"
                : "brightness(70%)",
              transition: "filter 0.3s ease-in-out",
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: selectedOptions.includes("notYet") ? "#FFF" : "#666",
            }}
          >
            Nothing Yet
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default WellnessPoll;
